import * as ACTION_TYPES from "../../actions/unitThermoking";

export const INITIAL_STATE = {
    unitsThermoking: [],
};

export const UnitThermokingReducer = (state = INITIAL_STATE, action) => {
  if (action.type === 'SESSION_RESET') return { ...INITIAL_STATE };
  switch (action.type) {
    case ACTION_TYPES.GET_ALL_UNITS_THERMOKING:
      return {
        ...state,
        unitsThermoking: action.payload,
      };
    default:
      return state;
  }
};
